import {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import * as appActions from '../../../store/actions/app';
import styles from './ButtonHeader.module.css';
import ButtonToggle from '../../ui/button-toggle/ButtonToggle';

function ButtonHeader() {
    const dispatch = useDispatch();
    const policyType = useSelector(state => state.app.policyType);
    const [selectedClaimType, setSelectedClaimType] = useState(policyType.active);

    // This controls if users see Personal or Commercial
    const selectClaimType = (type) => {
        setSelectedClaimType(type);
        dispatch(appActions.setPolicyType(policyType.personal, policyType.commercial, type));
    }

    useEffect(() => {
        selectClaimType(policyType.active);
    }, [policyType.active]); // eslint-disable-line react-hooks/exhaustive-deps

    return (   
        (policyType.personal && policyType.commercial) &&
        <div className={styles.buttonBar}>
            <ButtonToggle handleSelect={selectClaimType} selected={selectedClaimType}/>
        </div>
    )
}

export default ButtonHeader;
